module.exports = __webpack_public_path__ + "img/intro_s2_1.302258c1.png";